/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetType } from './rolloutTargetType';
import { ServiceCspUnGated } from './serviceCspUnGated';


/**
 * Details of the orgs to be targeted.
 */
export interface OrgWithOAuthAppsTargetResponse { 
    type?: RolloutTargetType;
    org_id: string;
    org_name?: string;
    org_type?: string;
    csp_ungated?: ServiceCspUnGated;
    vcf_oauth_app_count?: number;
    vmc_oauth_app_count?: number;
    vmc_pool_oauth_app_count?: number;
    asup_oauth_app_count?: number;
    drc_oauth_app_count?: number;
}
export namespace OrgWithOAuthAppsTargetResponse {
}


